/**
 * @file return-order.tsx
 * @module app/modules/orders-delivery/return-order
 * @description Orders delivery module component for UTrade Admin.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  CartonWithDozens,
  CartonWithPieces,
  Dozen,
  Piece,
  OrdersDelivery,
  StockUpdateReason,
  ReturnProductsRequestRejected,
} from "../../../../../utils/constants";
import Validations from "../../../../../utils/validations";
import clsx from "clsx";
import { getKey } from "../../../../../Global/history";
import { warehouse as warehouseStoreString } from "../../../../../utils/storeString";
import { error } from "../../../../../Global/toast";
import { useAuth } from "../../../auth";
import Method from "../../../../../utils/methods";
import { useWarehouse } from "../../../../context/WarehouseContext";
import { CustomSelectTable2 } from "../../../../custom/Select/custom-select-table";
import { submitOrderReturn } from "../../services/return-order.service";
import ImageWithFallback from "../../../_common/components/image-with-fallback";
const ReturnOrder = () => {
  const {currentUser} = useAuth();

  const { selectedWarehouse } = useWarehouse();
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [vehicleDetails, setVehicleDetails] = useState<any>();
  const [orderId, setOrderId] = useState<any>();
  const [selectedProduct, setSelectedProduct] = useState<any>([]);
  const [selectedReasons, setSelectedReasons] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const stockUpdateReasonOptions = [
    {
      value: StockUpdateReason.Missing,
      label: StockUpdateReason.Missing,
    },
    {
      value: StockUpdateReason.EnrouteDamaged,
      label: StockUpdateReason.EnrouteDamaged,
    },
    {
      value: StockUpdateReason.WrongItemDispatched,
      label: StockUpdateReason.WrongItemDispatched,
    },
    {
      value: StockUpdateReason.WrongItemSelected,
      label: StockUpdateReason.WrongItemSelected,
    },
    {
      value: StockUpdateReason.NoCash,
      label: StockUpdateReason.NoCash,
    },
    {
      value: StockUpdateReason.NearExpiry,
      label: StockUpdateReason.NearExpiry,
    },
  ];
  useEffect(() => {
    (async () => {
      let temp: any = [];
      console.log("state.vehicleDetails", state.vehicleDetails);
      state.vehicleDetails.variants.map((val: any) => {
        temp.push({
          variantID: val.variant._id,
          ...val,
          initialStock: val.stockCount,
          stockCount: val.returnedStockCount ? val.returnedStockCount : 0,
          stockUpdateReason: val.stockUpdateReason || "",
        });
      });
      await setSelectedProduct(temp);
      await setVehicleDetails(state.vehicleDetails);
      await setOrderId(state.orderId);
    })();
  }, []);
  const handleProductSelect = (event: any) => {
    const filteredArray: any = vehicleDetails.variants.find(
      (obj: any) => obj.variant._id === event.value
    );
    if (filteredArray) {
      let temp: any = [...selectedProduct];
      temp.push({ variant: event.value });
      setSelectedProduct(temp);
    }
  };
  const handleAddMore = () => {
    let temp: any = [...selectedProduct];
    temp.push({ variant: "", stockUpdateReason: "" });
    setSelectedProduct(temp);
  };
  const handleRemove = async (index: any) => {
    let temp = [...selectedProduct];
    temp.splice(index, 1);
    setSelectedProduct(temp);
  };
  const handleQuantityChange = (event: any, index: number) => {
    let temp = [...selectedProduct];
    if (event.target.value <= temp[index].initialStock) {
      temp[index].stockCount = event.target.value;
    }
    setSelectedProduct(temp);
  };
  const handleOnKeyPress = async (event: any) => {
    // Allow only numbers
    const key = event.key;
    let validations = await Validations.allowOnlyNumbers(key);
    if (!validations) {
      event.preventDefault();
      return false;
    }
    return true;
  };
  const handleReasonChange = (selected: any, index: number) => {
    setSelectedReasons((prev: any) => ({
      ...prev,
      [index]: selected?.value || "",
    }));
    const temp = [...selectedProduct];
    temp[index].stockUpdateReason = selected?.value || "";
    setSelectedProduct(temp);
  };
  const isReasonMissingForPositiveQty = selectedProduct.some(
    (val: any, index: number) =>
      Number(val.stockCount || 0) > 0 && !selectedReasons[index]
  );
  console.log("sss", selectedProduct);
  const handleSubmit = async () => {
    if (isReasonMissingForPositiveQty) {
      error("Please select reason for stock update.");
      return;
    }
    let temp: any = [];
    selectedProduct.map((val: any, index: number) => {
      const returnedStockCount = val.stockCount;
      const isQtyGreaterThanZero = Number(returnedStockCount || 0) > 0;
      temp.push({
        variant: val.variantID,
        quantityType: val.quantityType,
        returnedStockCount,
        stockUpdateReason: isQtyGreaterThanZero
          ? selectedReasons[index] || undefined
          : undefined,
      });
    });
    // const filteredData = temp.filter(
    //   (item: any) => parseInt(item.returnedStockCount) > 0
    // );
    if (temp.length) {
      setLoading(true);
      let response = await submitOrderReturn(
        orderId,
        {
          route: vehicleDetails.route,
          vehicle: vehicleDetails.vehicle,
          variants: temp,
        },
        selectedWarehouse?.value || null
      );
      if (response) {
        const data = selectedProduct.map((item: any) => {
          return {
            stockCount: item?.stockCount || "0",
            quantityType:
              item?.quantityType === CartonWithPieces ||
              item?.quantityType === CartonWithDozens
                ? "Cartoon"
                : item?.quantityType === Dozen
                ? "Dozen"
                : "Pieces",
            title: item?.variant?.title || "",
          };
        });

        window.history.back();
      }
      setLoading(false);
    }
  };
  return (
    <>
      <div className="p-5">
        <div className="mb-7">
          <h1 className="fs-22 fw-bolder">Return Order</h1>
        </div>
        <Card className="border bg-f9f9f9 mb-7">
          <Card.Body>
            <Row>
              <Col md={6} lg={4}>
                <Form.Label className="fs-16 fw-600 me-2">
                  Vehicle details:-{" "}
                </Form.Label>
                {vehicleDetails ? (
                  <>
                    {vehicleDetails.routeVehicle.driver ? (
                      <span className={clsx("fs-16 fw-500 text-dark")}>
                        {vehicleDetails.routeVehicle.driver.name}/{" "}
                        {vehicleDetails.routeVehicle.vehicle.number}
                      </span>
                    ) : (
                      <span className={clsx("fs-16 fw-500 text-danger")}>
                        Driver not allocated /{" "}
                        {vehicleDetails.routeVehicle.vehicle.number}
                      </span>
                    )}{" "}
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card className="border bg-f9f9f9 py-3">
          <Card.Header className="border-bottom-0 mb-3">
            <Card.Title className="fs-22 fw-bolder">
              Products & return quantities
            </Card.Title>
          </Card.Header>
          <Card.Body className="py-0">
            {selectedProduct.length ? (
              selectedProduct.map((productVal: any, productIndex: number) => {
                return (
                  <>
                    <Row className="align-items-center mb-6 g-3">
                      <Col md={5} lg={4}>
                        <Form.Label className="fs-16 fw-500">
                          Product
                        </Form.Label>
                        <Form.Label className="border form-control h-60px w-auto text-dark">
                          <div className="symbol symbol-30px border me-3">
                            <ImageWithFallback
                              src={productVal.variant.media[0].url}
                              className="object-fit-contain"
                              alt=""
                              noDefaultSize
                            />
                          </div>
                          <span className="fs-14 fw-600 text-black mb-0">
                            {productVal.variant.title.replace(/\s*\)\s*/g, ")")}
                          </span>
                        </Form.Label>
                      </Col>
                      <Col xs={11} md={6} lg={7}>
                        <Row className="align-items-center fs-16 fw-500 mb-1">
                          <Col xs>
                            <span>Quantity to return back</span>{" "}
                            {productVal?.stockUpdateReason && (
                              <span>due to {productVal.stockUpdateReason}</span>
                            )}
                          </Col>
                          <Col xs>
                            <span className="text-gray">
                              Processed Quantity:{" "}
                              {`${productVal.initialStock} ${
                                productVal.quantityType === CartonWithDozens ||
                                productVal.quantityType === CartonWithPieces
                                  ? "C"
                                  : ""
                              }
                         ${productVal.quantityType === Piece ? "P" : ""}
                          ${productVal.quantityType === Dozen ? "D" : ""}`}
                            </span>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col xs={12} sm={6} lg={3}>
                            <InputGroup className="border border-r8px">
                              <Form.Control
                                className="form-control-custom fs-16 fw-600 border-0 text-start bg-white pe-1"
                                disabled={
                                  !(
                                    productVal.quantityType ===
                                      CartonWithDozens ||
                                    productVal.quantityType === CartonWithPieces
                                  ) || state.returnProductsRequestStatus == ReturnProductsRequestRejected
                                }
                                value={
                                  productVal.quantityType ===
                                    CartonWithDozens ||
                                  productVal.quantityType === CartonWithPieces
                                    ? productVal.stockCount
                                    : "0"
                                }
                                onChange={(event: any) => {
                                  handleQuantityChange(event, productIndex);
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event);
                                }}
                              />
                              <InputGroup.Text className="fs-16 fw-600 text-gray bg-white border-0 ps-3">
                                cartons
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                          <Col xs={12} sm={6} lg={3}>
                            <InputGroup className="border border-r8px">
                              <Form.Control
                                className="form-control-custom fs-16 fw-600 border-0 text-start bg-white pe-1"
                                disabled={productVal.quantityType !== Dozen || state.returnProductsRequestStatus == ReturnProductsRequestRejected}
                                value={
                                  productVal.quantityType === Dozen
                                    ? productVal.stockCount
                                    : "0"
                                }
                                onChange={(event: any) => {
                                  handleQuantityChange(event, productIndex);
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event);
                                }}
                              />
                              <InputGroup.Text className="fs-16 fw-600 text-gray bg-white border-0 ps-3">
                                dozens
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                          <Col xs={12} sm={6} lg={3}>
                            <InputGroup className="border border-r8px">
                              <Form.Control
                                className="form-control-custom fs-16 fw-600 border-0 text-start bg-white pe-1"
                                disabled={productVal.quantityType !== Piece || state.returnProductsRequestStatus == ReturnProductsRequestRejected}
                                value={
                                  productVal.quantityType === Piece
                                    ? productVal.stockCount
                                    : "0"
                                }
                                onChange={(event: any) => {
                                  handleQuantityChange(event, productIndex);
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event);
                                }}
                              />
                              <InputGroup.Text className="fs-16 fw-600 text-gray bg-white border-0 ps-3">
                                pieces
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                          {Number(productVal.stockCount || 0) > 0 && (
                            <Col xs={12} sm={6} lg={3}>
                              <CustomSelectTable2
                                value={
                                  stockUpdateReasonOptions.find(
                                    (option: any) =>
                                      option.value ===
                                      selectedReasons[productIndex]
                                  ) || null
                                }
                                placeholder="Select reason"
                                onChange={(selected: any) =>
                                  handleReasonChange(selected, productIndex)
                                }
                                minWidth="220px"
                                minHieight="60px"
                                options={stockUpdateReasonOptions}
                                backgroundColor="#fff"
                              />
                            </Col>
                          )}
                        </Row>
                      </Col>
                      {/* {selectedProduct.length === productIndex ? (
                    <></>
                  ) : (
                    <>
                      <Col
                        xs={1}
                        className="text-end mt-6"
                      >
                        <Button
                          variant="link"
                          className="btn-flush"
                          onClick={() => {
                            handleRemove(productIndex);
                          }}
                        >
                          <img
                            width={22}
                            height={22}
                            className="img-fluid"
                            src={GrayCross}
                            alt=""
                          />
                        </Button>
                      </Col>
                    </>
                  )} */}
                    </Row>
                    {selectedProduct.length - 1 === productIndex ? (
                      <></>
                    ) : (
                      <>
                        <div className="separator my-6"></div>
                      </>
                    )}
                  </>
                );
              })
            ) : (
              <></>
            )}
          </Card.Body>
        </Card>
        {/* BUTTON */}
        <div className="d-flex justify-content-end mt-4">
          <Button
            size="lg"
            className="uw-btn uw-btn-primary uw-btn-lg min-h-lg-60px"
            disabled={loading}
            onClick={() => {
              handleSubmit();
            }}
          >
            {!loading && (
              <span className="indicator-label">Confirm returns</span>
            )}
            {loading && (
              <span className="indicator-progress" style={{ display: "block" }}>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};
export default ReturnOrder;
